
export default function withDebounce(func, wait) {
  let timeout = null;
  return function issueCallRequest(...args) {
    const context = this;
    const later = function onTimerComplete() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
